import * as moment from 'moment';
import * as types from '@/store/mutationTypes';
import { getStartMonthDate, getEndMonthDate, getStartWeekDate, getEndWeekDate } from '@/utils/dates';
import ActivitiesService from '@/http/services/activitiesService';

export const actions = {
    async getActivitiesCalendar({ state, commit }) {
        let dateFrom, dateTo;
        const { date, mode, selectedChild } = state;

        if (mode === 'Month') {
            dateFrom = getStartMonthDate(date);
            dateTo = getEndMonthDate(date);
        } else {
            dateFrom = getStartWeekDate(date);
            dateTo = getEndWeekDate(date);
        }

        dateFrom = moment(dateFrom).format('YYYY-MM-DD');
        dateTo = moment(dateTo).format('YYYY-MM-DD');

        const childIds = selectedChild ? [selectedChild.id] : null;

        const data = await ActivitiesService.getActivitiesCalendarDates({ dateFrom, dateTo, childIds });

        commit(types.SET_CALENDAR_ACTIVITY_DATES, data);
    },

    async getActivitiesCalendarByChild({ commit, dispatch }, selectedChild) {
        commit(types.SELECT_CHILD, selectedChild);
        await dispatch('getActivitiesCalendar');
    },

    async getActivitiesCalendarByAllChildren({ dispatch }) {
        dispatch('getActivitiesCalendarByChild', null);
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/calendar/actions.js